import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "text-lg font-bold text-left" }, "Jornada de trabalho", -1)
const _hoisted_2 = { class: "flex flex-col m-auto ml-0 rounded-lg overflow-hidden bg-[#F0F0F4] mb-6" }
const _hoisted_3 = { class: "flex items-start gap-2" }
const _hoisted_4 = { class: "flex flex-col gap-2 w-full" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "w-1/2" }, "Início", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "w-1/2" }, "Fim", -1)
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = { class: "flex justify-between items-center" }
const _hoisted_9 = { class: "flex gap-8 ml-3" }
const _hoisted_10 = { class: "flex gap-2" }
const _hoisted_11 = { class: "flex gap-2" }
const _hoisted_12 = { class: "flex items-start gap-2" }
const _hoisted_13 = { class: "flex flex-col gap-2 w-full" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "w-1/2" }, "Início", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "w-1/2" }, "Fim", -1)
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = { class: "flex justify-between items-center" }
const _hoisted_18 = {
  key: 1,
  class: "w-4 h-4 mt-1"
}
const _hoisted_19 = { class: "flex gap-8 ml-3" }
const _hoisted_20 = { class: "flex gap-2" }
const _hoisted_21 = { class: "flex gap-2" }

import { computed } from 'vue'
import SVGIcon from '@/components/SVGIcon.vue'
import DateTimeDisplay from './DateTimeDisplay.vue'
import { mdiMinusCircleOutline, mdiLockOpenVariant, mdiLock } from '@mdi/js'

type ApprovalStatus = 'Approved' | 'Rejected' | null

interface FormattedDateTime {
  weekday: string
  date: string
  time: string
}

const BG_NEUTRAL = 'bg-[#F0F0F4]'
const TEXT_MUTED = 'text-gray-400'


export default /*#__PURE__*/_defineComponent({
  __name: 'WorkJourneyDetailsSection',
  props: {
    originalStartHour: {},
    originalEndHour: {},
    requestedStartHour: {},
    requestedEndHour: {},
    timezone: {},
    approvalStatus: {}
  },
  setup(__props: any) {

const props = __props;



function formatDate(dateString?: string, timezone: string = '-03:00'): FormattedDateTime | null {
  if (!dateString) return null
  try {
    const date = new Date(dateString)
    if (isNaN(date.getTime())) return null
    const weekday = date.toLocaleDateString('pt-BR', { weekday: 'long', timeZone: timezone })
    const formattedDate = date.toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      timeZone: timezone
    })
    const formattedTime = date.toLocaleTimeString('pt-BR', {
      hour: '2-digit',
      minute: '2-digit',
      timeZone: timezone
    })
    return {
      weekday: weekday.charAt(0).toUpperCase() + weekday.slice(1),
      date: formattedDate,
      time: formattedTime
    }
  } catch {
    return null
  }
}

const formatDutyJourney = (dateString?: string): FormattedDateTime | null => {
  return formatDate(dateString, props.timezone || '-03:00')
}

const originalContainerClasses = computed(() => {
  if (props.approvalStatus === 'Approved')
    return 'rounded-lg border-2 border-[#F0F0F4] bg-[#F0F0F4]'
  if (props.approvalStatus === 'Rejected')
    return 'rounded-lg border-2 border-primary30 bg-[#E2E2E9]'
  return BG_NEUTRAL
})

const originalTextClasses = computed(() => {
  return props.approvalStatus === 'Approved' ? TEXT_MUTED : 'text-[#212529]'
})

const originalIcon = computed(() => {
  return props.approvalStatus === 'Rejected' ? mdiLock : mdiMinusCircleOutline
})

const originalIconClasses = computed(() => {
  if (props.approvalStatus === 'Approved') return TEXT_MUTED
  if (props.approvalStatus === 'Rejected') return 'text-primary30'
  return 'text-negative'
})

const requestedContainerClasses = computed(() => {
  if (props.approvalStatus === 'Approved') return 'bg-[#FCE5E8]'
  if (props.approvalStatus === 'Rejected') return BG_NEUTRAL
  return 'bg-[#FCE5E8]'
})

const requestedTextClasses = computed(() => {
  return props.approvalStatus === 'Rejected' ? TEXT_MUTED : 'text-[#212529]'
})

const requestedIconClasses = computed(() => {
  if (props.approvalStatus === 'Rejected') return TEXT_MUTED
  return 'text-negative'
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["px-6 py-4 rounded-t-lg", originalContainerClasses.value])
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", {
              class: _normalizeClass(["flex justify-between font-bold text-center", originalTextClasses.value])
            }, _hoisted_7, 2),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(SVGIcon, {
                path: originalIcon.value,
                class: _normalizeClass(["w-4 h-4 mt-1", originalIconClasses.value])
              }, null, 8, ["path", "class"]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(DateTimeDisplay, {
                    date: formatDutyJourney(_ctx.originalStartHour)?.date,
                    time: formatDutyJourney(_ctx.originalStartHour)?.time,
                    "text-class": originalTextClasses.value
                  }, null, 8, ["date", "time", "text-class"])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(DateTimeDisplay, {
                    date: formatDutyJourney(_ctx.originalEndHour)?.date,
                    time: formatDutyJourney(_ctx.originalEndHour)?.time,
                    "text-class": originalTextClasses.value
                  }, null, 8, ["date", "time", "text-class"])
                ])
              ])
            ])
          ])
        ])
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["px-6 py-4 rounded-b-lg", requestedContainerClasses.value])
      }, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", {
              class: _normalizeClass(["flex justify-between font-bold text-center", requestedTextClasses.value])
            }, _hoisted_16, 2),
            _createElementVNode("div", _hoisted_17, [
              (_ctx.approvalStatus !== 'Rejected')
                ? (_openBlock(), _createBlock(SVGIcon, {
                    key: 0,
                    path: _unref(mdiLockOpenVariant),
                    class: _normalizeClass(["w-4 h-4 mt-1", requestedIconClasses.value])
                  }, null, 8, ["path", "class"]))
                : (_openBlock(), _createElementBlock("div", _hoisted_18)),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(DateTimeDisplay, {
                    date: formatDutyJourney(_ctx.requestedStartHour)?.date,
                    time: formatDutyJourney(_ctx.requestedStartHour)?.time,
                    "text-class": requestedTextClasses.value
                  }, null, 8, ["date", "time", "text-class"])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createVNode(DateTimeDisplay, {
                    date: formatDutyJourney(_ctx.requestedEndHour)?.date,
                    time: formatDutyJourney(_ctx.requestedEndHour)?.time,
                    "text-class": requestedTextClasses.value
                  }, null, 8, ["date", "time", "text-class"])
                ])
              ])
            ])
          ])
        ])
      ], 2)
    ])
  ], 64))
}
}

})